import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export function openLessonWordsModal(): void {
  ModalComponent.attach("lessonWordsModal", appScope.id);
}
